// 配置一级菜单的路径，默认名称，图标
const menuConfig = {
    "/system": {
        name: "系统安全",
        icon: "setting"
    },
    "/goodsManage": {
        name: "商品管理",
        icon: "credit-card"
    },
    "/paymentCenter": {
        name: "资金管理",
        icon: "bank"
    },
    "/customerManage": {
        name: "客户管理",
        icon: "team"
    },
    "/orderManage": {
        name: "订单管理",
        icon: "profile"
    },
    "/contentManage": {
        name: "内容管理",
        icon: "folder-open"
    },
    "/marketing": {
        name: "营销中心",
        icon: "file-markdown"
    },
    "/labels": {
        name: "客户标签",
        icon: "tags"
    },
    "/flowDirection": {
        name: "流向查询",
        icon: "tags"
    },
    '/invoiceManage': {
        name: '发票管理',
        icon: 'credit-card'
    }
};
export default menuConfig;



// WEBPACK FOOTER //
// ./src/router/menuConfig.js